var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 78,
    viewBox: "0 0 79 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M66.7769 12.1875H13.1519C11.8589 12.1875 10.6189 12.7011 9.70471 13.6154C8.79047 14.5296 8.27686 15.7696 8.27686 17.0625V60.9375C8.27686 62.2304 8.79047 63.4704 9.70471 64.3846C10.6189 65.2989 11.8589 65.8125 13.1519 65.8125H66.7769C68.0698 65.8125 69.3098 65.2989 70.224 64.3846C71.1382 63.4704 71.6519 62.2304 71.6519 60.9375V17.0625C71.6519 15.7696 71.1382 14.5296 70.224 13.6154C69.3098 12.7011 68.0698 12.1875 66.7769 12.1875ZM66.7769 17.0625V26.8125H13.1519V17.0625H66.7769ZM66.7769 60.9375H13.1519V31.6875H66.7769V60.9375Z",
    fill: "#E1F4FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableicon);
export default __webpack_public_path__ + "static/media/tableicon.3cbe1ed9589ca610886db17f0f7bc0f0.svg";
export { ForwardRef as ReactComponent };